import { render, staticRenderFns } from "./DashboardPremium.vue?vue&type=template&id=3955852c&scoped=true&"
import script from "./DashboardPremium.vue?vue&type=script&lang=js&"
export * from "./DashboardPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955852c",
  null
  
)

export default component.exports